
import filters from "~/mixins/filters";

export default {
	mixins: [filters],
	props: {
		utilizationFee: {
			type: Object,
			default: null
		},
		isForm: {
			type: Boolean,
			default: false
		},
		vin: String,
		price: Number,
		minicard: {
			type: Boolean,
			default: false
		},
		priceOld: {
			type: String,
			default: ''
		}
	}
}
